import { withBreakpointObserver } from '@studiometa/js-toolkit';
import { Accordion as AccordionCore } from '@studiometa/ui';
import AccordionItem from '../../Sections/Accordion/AccordionItem.js';

/**
 * Accordion component
 */
export default class AccordionMenu extends withBreakpointObserver(AccordionCore) {
  /**
   * Component Configuration
   */
  static config = {
    name: 'AccordionMenu',
    options: {
      activeBreakpoints: {
        type: String,
        default: 'xxs xs s',
      },
    },
    components: {
      AccordionItem,
    },
  };
}
